<template>
  <div class="exam-body">
    <div class="subjective-content" v-if="readOnly">
      {{ checkValue[subjects.examQuestionsId] && checkValue[subjects.examQuestionsId].length ? checkValue[subjects.examQuestionsId] : "" }}
    </div>
    <el-input
      v-model="checkValue[subjects.examQuestionsId]"
      type="textarea"
      placeholder="请答题，答题框可在右下角拉伸"
      :rows="12"
      :readonly="readOnly"
      :maxlength="maxLength"
      show-word-limit
      @input="handleCheck"
      ondrop="return false"
      v-else
    ></el-input>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfExamSubjective",
  mixins: [$mixins.examControl],
  ctrlCaption: "主观题",
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    maxLength: {
      type: [String, Number],
      default: 2000,
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("exam-subjective-meta-data");
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
});
</script>
